var LOADING_MODE = {
    BLUR: 'BLUR',
    COLOR: 'COLOR',
    MAIN_COLOR: 'MAIN_COLOR',
    NONE: 'NONE',
};
export default LOADING_MODE;
//# sourceMappingURL=loadingMode.js.map